<script setup lang="ts">
import { ref } from 'vue'
import CreateEntity from "@/domains/home/services/nir/registration/views/CreateEntity.vue";
import CreateData from "@/domains/home/services/nir/registration/views/CreateData.vue";

type ViewMode = 'entity' | 'bulkData'

const activeView = ref<ViewMode>('entity')

function close() {
  activeView.value = 'entity'
}

const toggleView = (view: ViewMode) => {
  activeView.value = view
}

</script>

<template>
  <div class="flex bg-white p-4 rounded">
    <div class="w-8/12 mx-auto">
      <div class="flex-1 flex flex-col overflow-hidden bg-white p-4">
        <!-- Toggle Button Group -->
<!--        <div class="flex items-center justify-end mb-4">-->
<!--          <div class="inline-flex bg-gray-100 rounded-lg p-1 gap-1">-->
<!--            <button-->
<!--                @click="toggleView('entity')"-->
<!--                :class="[-->
<!--            'px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 flex items-center space-x-2',-->
<!--            activeView === 'entity'-->
<!--              ? 'bg-primary text-white shadow-sm'-->
<!--              : 'text-gray-700 hover:text-gray-900 hover:bg-gray-200'-->
<!--          ]"-->
<!--            >-->
<!--              <i class="fa-solid fa-plus"></i>-->
<!--              <span>Add Entity</span>-->
<!--            </button>-->

<!--            <button-->
<!--                @click="toggleView('bulkData')"-->
<!--                :class="[-->
<!--            'px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 flex items-center space-x-2',-->
<!--            activeView === 'bulkData'-->
<!--              ? 'bg-primary text-white shadow-sm'-->
<!--              : 'text-gray-700 hover:text-gray-900 hover:bg-gray-200'-->
<!--          ]"-->
<!--            >-->
<!--              <i class="fa-solid fa-file-excel"></i>-->
<!--              <span>Add Bulk Data</span>-->
<!--            </button>-->
<!--          </div>-->
<!--        </div>-->

        <!-- Content Area -->
        <div class="flex flex-col">
<!--          <CreateEntity v-if="activeView === 'entity'" @close="close" />-->
          <CreateData @close="close" />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
